import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import { getIndicatorConfig } from 'utils/common';
import { useFormatNumber, useText } from 'common/hooks';
import { GOAL_STATUS, ICON } from 'resources/constants';

import {
  GoalWrapper,
  Text,
  Label,
  EditButton,
  ButtonText,
  Icon,
  TopWrapper,
} from './elements';

const deps = {
  currentGoal: state.challenge.info.computedCurrentGoal,
  indicator: state.challenge.campaign.indicator,
  goalModalClicked: sequences`challenge.info.goalModalClicked`,
};

export function Goal({
  currentGoal,
  indicator,
  goalModalClicked,
}: typeof deps & ConnectedProps): React.ReactElement {
  const { color, icon } = getIndicatorConfig(indicator);
  const formatNumber = useFormatNumber();
  const t = useText();

  return (
    <TopWrapper>
      <GoalWrapper>
        <Text>{t('challenge.ChaPaD24B.PersonalInsights.goals.goal')}</Text>
        <Label icon={icon} color={color}>
          {currentGoal.status === GOAL_STATUS.NONE
            ? '-'
            : formatNumber(currentGoal?.goal?.score / 1_000_000)}
        </Label>
      </GoalWrapper>
      {currentGoal.status === GOAL_STATUS.CURRENT && (
        <EditButton onClick={() => goalModalClicked()}>
          <ButtonText>
            {t('challenge.ChaPaD24B.PersonalInsights.goals.edit_goal')}
          </ButtonText>
          <Icon icon={ICON.modeEdit} />
        </EditButton>
      )}
    </TopWrapper>
  );
}

export default connect(deps, Goal);
